import Helper from '@/modules/helper';
import I18n from '@/modules/i18n';
import notify from '@/modules/notify';

export default class FormValidator {
  constructor(options) {
    this.errors = $('[data-error]');
    this.form = options.form;
    this.globalError = $('[data-global-error]');
    this.modal = document.querySelector('[data-modal]');
    this.modalBody = document.querySelector('[data-modal-body]');
    this.options = options;
    this.submitButtons = document.querySelectorAll('[data-submit]');
  }

  bindSubmit() {
    for (const button of this.submitButtons) {
      if (button.type === 'submit') {
        console.warn('Form Validator already submits [data-submit] so submit button should be avoided!');

        continue;
      }

      button.addEventListener('click', () => {
        this.cleanErrors();

        this.validator.validaty('validate', this.form.querySelectorAll('[data-validaty]'));
      });
    }
  }

  bindValidation() {
    this.validator = $(this.form).validaty({
      bindSubmit: false,
      errorTarget: this.errorTarget.bind(this),
      onInvalid: this.onInvalid.bind(this),
      onValid: this.onValid.bind(this),
    });
  }

  cleanErrors() {
    this.errors.empty();
    this.globalError.hide().empty();
  }

  create() {
    this.bindSubmit();

    this.bindValidation();

    return this;
  }

  errorTarget(field, message) {
    const errorEl = field[0].parentElement.querySelector('[data-error]');

    if (errorEl) {
      errorEl.appendChild(message[0]);
    } else {
      message.insertAfter(field[0]);
    }
  }

  #modal() {
    const element = this.modal.closest('[data-controller~="modal"]');

    return window.Stimulus.getControllerForElementAndIdentifier(element, 'modal');
  }

  onInvalid(_fields) {
    this.resetState();

    const firstFieldWithError = this.form.querySelector('.invalid');

    Helper.scrollTo(firstFieldWithError);

    firstFieldWithError.focus();

    this.options.onInvalid?.();
  }

  onValid(_fields) {
    this.options.onValid?.();
  }

  resetState() {
    // FIXME: it does not works without timeout
    setTimeout(() => {
      if (this.modal) this.#modal().close();

      for (const button of this.submitButtons) {
        button.disabled = false;

        const originalText = button.dataset.originalText;

        if (button.type === 'submit') {
          button.value = originalText;
        } else {
          button.innerText = originalText;
        }
      }
    }, 500);
  }

  showErrors(json) {
    if (json) {
      const errors = json.errors;

      if (errors) this.showFieldErrors(errors);
    } else if (response.responseText) {
      notify({ title: `${response.responseText.substring(0, 80)}...` });
    } else {
      notify({ title: I18n.t('api_error') });
    }

    this.resetState();
  }

  showFieldErrors(errors) {
    if (typeof errors === 'object') {
      for (let i = 0; i < errors.length; i++) {
        const placeholder = $('[data-' + errors[i].id + '-error]');

        if (placeholder.length) {
          placeholder.append(errors[i].message);

          if (i === 0) {
            Helper.scrollTo(placeholder.show());
          }
        } else {
          notify({ title: errors[i].message });
        }
      }
    } else {
      notify(errors);
    }

    this.resetState();
  }

  showModal(body) {
    this.modalBody.innerHTML = body;
    this.#modal().open();
  }
}
